
import './App.css';
import Homepage from './pages/home-page/homepage';

function App() {
  return (
    
    <div className="App">
      <Homepage />
    </div>
  );
}

export default App;
